import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Check } from "@phosphor-icons/react";
import { useAuth, login } from "@/context/AuthContext";
import { startCheckout, errMsg } from "@/lib/api";
import { useT } from "@/i18n";

const PLANS = [
  { id: "free", name: "Free", price: "€0", note: "forever", features: ["Listing Grader & House Rules Generator", "1 saved property", "5 AI generations / month", "Shareable guidebook link"] },
  { id: "pro", key: "pro_monthly", name: "Pro", price: "€12", note: "/ month", featured: true, features: ["Unlimited-feel listing rewrites (300 AI / month)", "Guest messages in 10 languages", "AI guidebook builder + PDF", "Up to 3 properties"] },
  { id: "manager", key: "manager_monthly", name: "Manager", price: "€79", note: "/ month", features: ["Up to 20 properties", "1,500 AI generations / month", "All Pro features", "Priority support"] },
];

export const PricingCards = () => {
  const { user } = useAuth();
  const { t } = useT();
  const nav = useNavigate();
  const [busy, setBusy] = useState(null);
  const choose = async (p) => {
    if (p.id === "free") { user ? nav("/app") : login(); return; }
    if (!user) { toast.message(t("Sign in first, then choose your plan.")); login(); return; }
    setBusy(p.id);
    try { await startCheckout(p.key); } catch (e) { toast.error(errMsg(e)); setBusy(null); }
  };
  return (
    <div className="grid gap-6 lg:grid-cols-3" data-testid="pricing-cards">
      {PLANS.map((p) => {
        const current = user?.plan === p.id;
        return (
          <div key={p.id} className={`card card-hover p-8 flex flex-col ${p.featured ? "!bg-[#0F4C5C] !border-[#0F4C5C] text-[#F4E9D8]" : ""}`} data-testid={`plan-card-${p.id}`}>
            <div className="flex items-center justify-between">
              <h3 className={`text-2xl ${p.featured ? "text-[#F4E9D8]" : "text-[#0F4C5C]"}`}>{p.name}</h3>
              {p.featured && <span className="text-xs bg-[#E36414] text-white px-3 py-1 rounded-full font-semibold">{t("Most hosts")}</span>}
            </div>
            <p className="mt-4"><span className="font-display text-5xl">{p.price}</span> <span className="opacity-70">{t(p.note)}</span></p>
            <ul className="mt-6 space-y-3 flex-1">
              {p.features.map((f) => <li key={f} className="flex gap-2 text-sm"><Check size={18} className="text-[#E36414] shrink-0" weight="bold" /> {t(f)}</li>)}
            </ul>
            <button disabled={busy === p.id || current} onClick={() => choose(p)}
              className={`mt-8 justify-center ${p.featured ? "btn-coral" : "btn-ghost"}`} data-testid={`plan-select-${p.id}-btn`}>
              {current ? t("Your current plan") : busy === p.id ? t("Opening checkout…") : p.id === "free" ? t("Start free") : t("Choose {name}", { name: p.name })}
            </button>
          </div>
        );
      })}
    </div>
  );
};
